import React, { useState, useEffect } from "react";

const OAuthButton = ({ platform, adsConfiguration, disabled = false }) => {
  const [authUrl, setAuthUrl] = useState("");

  useEffect(() => {
    setAuthUrl(adsConfiguration?.authUrl || "");
  }, [adsConfiguration]);

  const handleLogin = () => {
    if (authUrl && !disabled) {
      window.location.href = authUrl;
    }
  };

  return (
    <button
      className={`px-4 py-2 rounded-lg text-white ${
        disabled
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#221C51] hover:bg-[#1a1641]"
      }`}
      onClick={handleLogin}
      disabled={disabled}
    >
      Authorise
    </button>
  );
};

export default OAuthButton;
